import '@tensorflow/tfjs-backend-webgl';
//import * as mpPose from '@mediapipe/pose';
import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';
import * as poseDetection from '@tensorflow-models/pose-detection';
import * as tf from '@tensorflow/tfjs-core';
import * as faceMesh from '@mediapipe/face_mesh';
import * as faceLandmarksDetection from '@tensorflow-models/face-landmarks-detection';
import * as handLandmarksDetection from '@tensorflow-models/hand-pose-detection';
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import Webcam from 'react-webcam'
import * as canvasUtils from '../util/LandmarksUtils';
import $, { trim } from 'jquery'
import Nouislider from 'nouislider-react';
import MP4Demuxer from '../util/mp4-decode/mp4_demuxer'
import WebMWriter from 'webm-writer';
import {
    NavItem,
    NavLink,
    Nav,
    Container,
    Row,
    Col,
    Button
} from 'reactstrap'
import classnames from 'classnames'
import { LanguageContext } from "../App"
import Animator from './Animator';
import {globallandmarks_include_map, facelandmarks_include_map, globaltophandlandmarks_include_map, faceglobaltophandlandmarks_include_map, facegloballandmarks_include_map, globalhandlandmarks_include_map, faceglobalhandlandmarks_include_map} from '../util/LandmarksConfigs';
import InfoFillTable from './InfoFillTable';
import LandmarkImage from '../util/images/PLD.png';
import GMS_LandmarkImage from '../util/images/PLD_GMS.png';
import FMS_LandmarkImage from '../util/images/PLD_FMS.png';
import FE_LandmarkImage from '../util/images/PLD_FE.png';
import GMS_FMS_LandmarkImage from '../util/images/PLD_GMS-FMS.png';
import GMS_FE_LandmarkImage from '../util/images/PLD_GMS-FE.png';
import FMS_FE_LandmarkImage from '../util/images/PLD_FMS-FE.png';
import GMS_FMS_FE_LandmarkImage from '../util/images/PLD_GMS-FMS-FE.png';
import {Camera} from './camera';
import {RendererCanvas2d} from './renderer_canvas2d';
import {STATE} from './params';

tfjsWasm.setWasmPaths(
    `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${
        tfjsWasm.version_wasm}/dist/`);
        
let global_vars = {
    frame_count :0,
    nb_frames:0,
    start_time: 0,
    landmarks : {
        frequency : 0.0,
        landmarks:[],
        landmarkConfig:[]
    },
    timestamps: {
        duration:0,
        first_timestamp:0,
        second_timestamp:0,
        step:0
    },
    options : [],
    images : []
}
let globaldetector
let camera
let video
let renderer = null;
let faceLandmarksdetector
let handLandmarksdetector
let rafId;

const blazepose_configs = {
    model: poseDetection.SupportedModels.BlazePose,
    estimation_configs:{
        runtime:'tfjs',
        flipHorizontal:false,
        enableSmoothing:true,
    },
    config:{
        runtime:'tfjs',
        //staticImageMode : false,
        modelType:'heavy', // lite full heavy
        flipHorizontal:false,
        enableSmoothing:true,
        solutionPath : 'https://cdn.jsdelivr.net/npm/@mediapipe/pose'
        //modelComplexity:true,
        //maxNumFace : 1
        //minDetectionConfidence : 0.5
        //minTrackingConfidence : 0.5
    },
}
const facelandmarks_configs = {
    model: faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh,
    estimation_configs:{
        runtime:'tfjs',
        flipHorizontal:false,
        //enableSmoothing:true,
    },
    config:{
        runtime:'tfjs',
        //modelType:'heavy',
        flipHorizontal:false,
        refineLandmarks: false, // For accurate IRIS position
        maxFaces: 1,
        enableSmoothing:true,
        solutionPath: `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh@${
              faceMesh.VERSION}`
    },
}

const handlandmarks_configs = {
    model: handLandmarksDetection.SupportedModels.MediaPipeHands,
    estimation_configs:{
        runtime:'tfjs',
        flipHorizontal:false,
        //enableSmoothing:true,
    },
    config:{
        runtime:'tfjs',
        //modelType:'heavy',
        flipHorizontal:false,
        //enableSmoothing:true,
        solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/hands'
    },
}

const Detector = ()=>{
    const language = useContext(LanguageContext)
    const webcamRef = useRef(null)
    const canvasRef = useRef(null)
    const canvasWebcamRef = useRef(null)
    const detectionCanvas = useRef(null)
    const videoRef = useRef(null)
    const videoToExportRef = useRef(null)
    const exportingToVideoCanvRef = useRef(null)
    const videoSrcRef = useRef(null)
    const exportVidBtnRef = useRef(null)
    const exportVidBtnRefPLD = useRef(null)
    const [selectedVideo,setSelectedVideo] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isChoicesVisible, setIsChoicesVisible] = useState(false);
    const [isVideoSelected,setIsVideoSelected] = useState(false)
    const [videoDuration,setVideoDuration] = useState(0.0)
    const [isVideoLoaded,setIsVideoLoaded] = useState(false)
    const [isVideoProcessing,setIsVideoProcessing] = useState(false)
    const [isWebcamProcessing,setIsWebcamProcessing] = useState(false)
    const [submitCounter,setSumbitCounter] = useState(0)
    const [videoHeight,setVideoHeight] = useState(480)
    const [videoWidth,setVideoWidth] = useState(640)
    const [webcamHeight,setWebcamHeight] = useState(480)
    const [webcamWidth,setWebcamWidth] = useState(640)
    const [detectorType,setDetectorType] = useState('blazepose')
    const [detectorConfigs,setDetectorConfigs] = useState({})
    const [detectorConfigsFace,setDetectorConfigsFace] = useState({})
    const [detectorConfigsHand,setDetectorConfigsHand] = useState({})
    const [transformedLandmarks,setTransformedLandmarks] = useState({})
    const [uploaderChangeCounter,setUploaderChangeCounter] = useState(0)
    const [rotate,setRotate] = useState(false)
    const [fillableTableData,setFillableTableData] = useState([])
    const [infoFilledCounter,setInfoFilledCounter] = useState(0)
    const [selectedImage, setSelectedImage] = useState(LandmarkImage);
    const [isRecording, setIsRecording] = useState(false);
    let global_vars2 = {
        landmarkConfig : []
    }  
    const toggleNavs = (e,detectorType) =>{
        e.preventDefault()
        setIsChoicesVisible(detectorType === "webcam");
        setSelectedImage(LandmarkImage);
        setSelectedVideo([]);
    }
    const handleGlobalMotorSkills = () => {
        setSelectedOptions((prevSelected) => {
            const isSelectedGMS = prevSelected.includes('global_motor_skills');
            const isSelectedFMS = prevSelected.includes('fine_motor_skills');
            const isSelectedFE = prevSelected.includes('face_expression');
            if (!isSelectedGMS && isSelectedFMS && isSelectedFE) {
                setSelectedImage(GMS_FMS_FE_LandmarkImage);
            } else if (!isSelectedGMS && isSelectedFMS){
                setSelectedImage(GMS_FMS_LandmarkImage);
            } else if (!isSelectedGMS && isSelectedFE){
                setSelectedImage(GMS_FE_LandmarkImage);
            } else if (isSelectedFMS && isSelectedFE){
                setSelectedImage(FMS_FE_LandmarkImage);
            } else if (!isSelectedGMS){
                setSelectedImage(GMS_LandmarkImage);
            } else if (isSelectedFMS){
                setSelectedImage(FMS_LandmarkImage);
            } else if (isSelectedFE){
                setSelectedImage(FE_LandmarkImage);
            } else {
                setSelectedImage(LandmarkImage);
            }
            return isSelectedGMS ? prevSelected.filter((value) => value !== 'global_motor_skills') : [...prevSelected, 'global_motor_skills'];
        });
    };
    const handleFineMotorSkills = () => {
        setSelectedOptions((prevSelected) => {
            const isSelectedGMS = prevSelected.includes('global_motor_skills');
            const isSelectedFMS = prevSelected.includes('fine_motor_skills');
            const isSelectedFE = prevSelected.includes('face_expression');
            if (isSelectedGMS && !isSelectedFMS && isSelectedFE) {
                setSelectedImage(GMS_FMS_FE_LandmarkImage);
            } else if (isSelectedGMS && !isSelectedFMS){
                setSelectedImage(GMS_FMS_LandmarkImage);
            } else if (isSelectedGMS && isSelectedFE){
                setSelectedImage(GMS_FE_LandmarkImage);
            } else if (!isSelectedFMS && isSelectedFE){
                setSelectedImage(FMS_FE_LandmarkImage);
            } else if (isSelectedGMS){
                setSelectedImage(GMS_LandmarkImage);
            } else if (!isSelectedFMS){
                setSelectedImage(FMS_LandmarkImage);
            } else if (isSelectedFE){
                setSelectedImage(FE_LandmarkImage);
            } else {
                setSelectedImage(LandmarkImage);
            }
            return isSelectedFMS ? prevSelected.filter((value) => value !== 'fine_motor_skills') : [...prevSelected, 'fine_motor_skills'];
        });
    };
    const handleFaceExpression = () => {
        setSelectedOptions((prevSelected) => {
            const isSelectedGMS = prevSelected.includes('global_motor_skills');
            const isSelectedFMS = prevSelected.includes('fine_motor_skills');
            const isSelectedFE = prevSelected.includes('face_expression');
            if (isSelectedGMS && isSelectedFMS && !isSelectedFE) {
                setSelectedImage(GMS_FMS_FE_LandmarkImage);
            } else if (isSelectedGMS && isSelectedFMS){
                setSelectedImage(GMS_FMS_LandmarkImage);
            } else if (isSelectedGMS && !isSelectedFE){
                setSelectedImage(GMS_FE_LandmarkImage);
            } else if (isSelectedFMS && !isSelectedFE){
                setSelectedImage(FMS_FE_LandmarkImage);
            } else if (isSelectedGMS){
                setSelectedImage(GMS_LandmarkImage);
            } else if (isSelectedFMS){
                setSelectedImage(FMS_LandmarkImage);
            } else if (!isSelectedFE){
                setSelectedImage(FE_LandmarkImage);
            } else {
                setSelectedImage(LandmarkImage);
            }
            return isSelectedFE ? prevSelected.filter((value) => value !== 'face_expression') : [...prevSelected, 'face_expression'];
        });
    };

    const handleProcessAllSelectedOptions = async () => {
        if (!isChoicesVisible) {
            const endpoints = selectedOptions.map(option => {
                switch (option) {
                    case 'global_motor_skills':
                        return processVideoHandler();
                    case 'fine_motor_skills':
                        return processVideoHandler();
                    case 'face_expression':
                        return processVideoHandler();
                    default:
                        return null;
                }
            }).filter(Boolean);
        } else {
            console.log("Webcam detection mode selected. Implement the real-time detection logic here.");
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    // Decoding
    const [videoDecoder,setVideoDecoder] = useState(null)
    const [videoDemuxer,setVideoDemuxer] = useState(null)
    const [isVideoProcessed,setIsVideoProcessed ]= useState(false)
    const [frameCount,setFrameCount] = useState(0)

    const getFrameStats = () => {
        let now = performance.now();
        let fps = "";
        if (global_vars.frame_count++) {
            let elapsed = now - global_vars.start_time;
            fps = " (" + (1000.0 * global_vars.frame_count / (elapsed)).toFixed(0) + " fps)"
        } else {
          // This is the first frame.
          global_vars.start_time = now;
        }
  
        return "Extracted " + global_vars.frame_count + " / "+global_vars.nb_frames+" frames" + fps;
    }
    const setDecoder = async ()=>{
        let decoder = new VideoDecoder({ // eslint-disable-line
            output : handleFrame,
            error : e => console.error(e),
        });
        return decoder
    }

    const handleFrame = (frame)=>{
        let canvas_ctx = null
        try{
            canvas_ctx = canvasRef.current.getContext('2d')
            }
        catch(e){console.log(e.message)}
        // global_vars.images.push(frame.clone())
        if (canvas_ctx){
            let landmarks_map = []
            let kp = null
            if(!global_vars.timestamps.second_timestamp){
                if(global_vars.timestamps.first_timestamp>0){
                    global_vars.timestamps.second_timestamp = frame.timestamp
                    let diff_step = global_vars.timestamps.second_timestamp - global_vars.timestamps.first_timestamp
                    if((global_vars.timestamps.step === diff_step) && diff_step){
                        global_vars.nb_frames=parseInt(global_vars.nb_frames / 2)
                    }
                }
            }
            if(!global_vars.timestamps.first_timestamp){
                global_vars.timestamps.first_timestamp = frame.timestamp
            }
            
            canvas_ctx.drawImage(frame, 0, 0,canvasRef.current.width,canvasRef.current.height);
            detectionCanvas.current.getContext('2d').drawImage(frame, 0, 0,detectionCanvas.current.width,detectionCanvas.current.height);
            let lconfig = null
            let res = null
            let new_lconfig = [[]]
            let new_landmarks = Object.values(JSON.parse(JSON.stringify(global_vars.confLandmarks)))
            const endpoints = global_vars.options_copy.map(option => {
                switch (option) {
                    case 'global_motor_skills':
                        detectPoses(detectionCanvas.current).then((landmarks)=>{
                            if(landmarks){
                                if(landmarks[0]){
                                    landmarks?.forEach(element => {
                                            res = canvasUtils.liveDrawMovenetLandmarks(
                                                canvas_ctx,
                                                element,
                                                false,
                                                canvasRef.current.width,
                                                canvasRef.current.height,
                                                detectionCanvas.current.width,
                                                detectionCanvas.current.height,
                                                option,
                                                new_landmarks
                                                )
                                            new_landmarks = res.first
                                            lconfig = res.second
                                            Array.prototype.push.apply(new_lconfig[0],lconfig)
                                    });
                                }
                            }
                        })
                        return
                    case 'fine_motor_skills':
                        detectHandLandmarks(detectionCanvas.current).then((landmarks)=>{
                            if(landmarks){
                                if(landmarks[0]){
                                    landmarks?.forEach(element => {
                                            res = canvasUtils.liveDrawMovenetLandmarks(
                                                canvas_ctx,
                                                element,
                                                false,
                                                canvasRef.current.width,
                                                canvasRef.current.height,
                                                detectionCanvas.current.width,
                                                detectionCanvas.current.height,
                                                option,
                                                new_landmarks
                                                )
                                            new_landmarks = res.first
                                            lconfig = res.second
                                            Array.prototype.push.apply(new_lconfig[0],lconfig)
                                    });
                                }
                            }
                        })
                        return
                    case 'face_expression':
                        detectFaceLandmarks(detectionCanvas.current).then((landmarks)=>{
                            if(landmarks){
                                if(landmarks[0]){
                                    landmarks?.forEach(element => {
                                            res = canvasUtils.liveDrawMovenetLandmarks(
                                                canvas_ctx,
                                                element,
                                                false,
                                                canvasRef.current.width,
                                                canvasRef.current.height,
                                                detectionCanvas.current.width,
                                                detectionCanvas.current.height,
                                                option,
                                                new_landmarks
                                                )
                                            new_landmarks = res.first
                                            lconfig = res.second
                                            Array.prototype.push.apply(new_lconfig[0],lconfig)
                                    });
                                }
                            }
                        })
                        return
                    default:
                        return null;
                }
            }).filter(Boolean);
            frame.close();
            let new_landmarks2 = [[]]
            Array.prototype.push.apply(new_landmarks2[0],new_landmarks)
            if (new_lconfig){
                global_vars.landmarks.landmarkConfig.push(new_lconfig)
            }
            else{
                global_vars.landmarks.landmarkConfig.push([[]])
            }
            
            if (new_landmarks){
                global_vars.landmarks.landmarks.push(new_landmarks2)
            }
            else{
                global_vars.landmarks.landmarks.push([[]])
            }
            
            // Draw some optional stats.
            canvasRef.current.getContext('2d').font = '25px sans-serif';
            canvasRef.current.getContext('2d').fillStyle = "#ffffff";
            canvasRef.current.getContext('2d').fillText(getFrameStats(), 40, 40, canvasRef.current.width);
            if(global_vars.nb_frames && (global_vars.frame_count+11 >= global_vars.nb_frames)){
                setFrameCount(global_vars.nb_frames)
                setTimeout(() => {
                    setIsVideoProcessed(true)
                    setIsVideoProcessing(false)
                }, 2000);
            }
            let connect_slider = $('.noUi-connect')
            let transform_value = ((global_vars.nb_frames-global_vars.frame_count) / global_vars.nb_frames) * (-1000)
            connect_slider.css("transform","translate(0%,0px) scale("+global_vars.frame_count/global_vars.nb_frames+",1)")
        }
        
    }

    useEffect(()=>{
        if (isVideoProcessed){
            let landmarks = transformLandmarks('json')
            setTransformedLandmarks(landmarks)
            let a = document.createElement('a')
            a.href = '#pld_animator'
            a.click()
        }
    },[isVideoProcessed])


    useEffect(()=>{
        if(isVideoLoaded){
            let demuxer = new MP4Demuxer(videoSrcRef.current.src)
            setVideoDemuxer(demuxer)
            setIsVideoProcessing(false)
        }
        
    },[isVideoLoaded,submitCounter])

    useEffect(()=>{
        setDecoder().then((decoder)=>{
            setVideoDecoder(decoder)
        })
        
    },[])

    useEffect(()=>{
        if(isVideoProcessing){
            $('#noui-process .noUi-connect')?.addClass('bg-dark')
            $('#noui-process .noUi-handle')?.remove()
        } 
    },[isVideoProcessing])

    const processVideo = async ()=> {
        global_vars = {
            frame_count :0,
            nb_frames:0,
            start_time: 0,
            landmarks : {
                frequency : 0.0,
                landmarks:[],
                landmarkConfig:[]
            },
            timestamps: {
                duration:0,
                first_timestamp:0,
                second_timestamp:0,
                step:0
            },
            options : [],
            options_copy :[],
            confLandmarks : [],
            // images : []
        }
        if((isVideoLoaded && videoDemuxer && !isVideoProcessed)) {
            setIsVideoProcessing(true)
            videoDemuxer.getConfig().then((config) => {
                videoDecoder.configure(config);
                let duration = videoDemuxer.track.duration
                let step = 0
                try{
                    step = videoDemuxer.track?.edits[0]?.media_time
                }
                catch(e){
                    //
                }
                global_vars.options = selectedOptions
                let global_motor_skills_flag = false
                let fine_motor_skills_flag = false
                let face_expression_flag = false
                const endpoints_p = global_vars.options.map(option => {
                    switch (option) {
                        case 'global_motor_skills':
                            global_motor_skills_flag = true
                            return
                        case 'fine_motor_skills':
                            fine_motor_skills_flag = true
                            return
                        case 'face_expression':
                            face_expression_flag = true
                            return
                        default:
                            return null;
                    }
                }).filter(Boolean);
                global_vars.options_copy = JSON.parse(JSON.stringify(global_vars.options))
                if(global_motor_skills_flag && fine_motor_skills_flag && face_expression_flag){
                    globallandmarks_include_map[0].include = false
                    globallandmarks_include_map[15].include = false
                    globallandmarks_include_map[16].include = false
                    global_vars.confLandmarks = faceglobalhandlandmarks_include_map
                } else if (global_motor_skills_flag && fine_motor_skills_flag){
                    globallandmarks_include_map[15].include = false
                    globallandmarks_include_map[16].include = false
                    global_vars.confLandmarks = globalhandlandmarks_include_map
                } else if (global_motor_skills_flag && face_expression_flag){
                    globallandmarks_include_map[0].include = false
                    global_vars.confLandmarks = facegloballandmarks_include_map
                } else if (face_expression_flag && fine_motor_skills_flag){
                    globallandmarks_include_map[0].include = false
                    globallandmarks_include_map[15].include = false
                    globallandmarks_include_map[16].include = false
                    globallandmarks_include_map[23].include = false
                    globallandmarks_include_map[24].include = false
                    globallandmarks_include_map[25].include = false
                    globallandmarks_include_map[26].include = false
                    globallandmarks_include_map[27].include = false
                    globallandmarks_include_map[28].include = false
                    global_vars.options_copy.push('global_motor_skills')
                    global_vars.confLandmarks = faceglobaltophandlandmarks_include_map
                } else if (fine_motor_skills_flag){
                    globallandmarks_include_map[15].include = false
                    globallandmarks_include_map[16].include = false
                    globallandmarks_include_map[23].include = false
                    globallandmarks_include_map[24].include = false
                    globallandmarks_include_map[25].include = false
                    globallandmarks_include_map[26].include = false
                    globallandmarks_include_map[27].include = false
                    globallandmarks_include_map[28].include = false
                    global_vars.options_copy.push('global_motor_skills')
                    global_vars.confLandmarks = globaltophandlandmarks_include_map
                } else if (face_expression_flag){
                    global_vars.confLandmarks = facelandmarks_include_map
                } else if (global_motor_skills_flag){
                    global_vars.confLandmarks = globallandmarks_include_map
                }
                global_vars.timestamps.duration = duration
                global_vars.timestamps.step = step
                global_vars.nb_frames = videoDemuxer.track.nb_samples
                videoDemuxer.start((chunk) => {
                    videoDecoder.decode(chunk)
                })
            });
        }
        return 0
        
    }

    const processVideoHandler = async ()=>{
        await processVideo()
    }
    //////////////////////////////////////////////////////////////////////////////////////////////
    // Detect poses in image
    const detectPoses = async(img) =>{
        try{
            let poses = await globaldetector.estimatePoses(img,detectorConfigs.estimation_configs)
            return poses
        }
        catch(e){
            console.log(e)
        }
    }
    
    //////////////////////////////////////////////////////////////////////////////////////////////
    // Detect face landmarks in image
    const detectFaceLandmarks = async(img) =>{
        try{
            let faceLandmarks = await faceLandmarksdetector.estimateFaces(img,detectorConfigsFace.estimation_configs)
            return faceLandmarks
        }
        catch(e){
            console.log(e)
        }
    }
    
    //////////////////////////////////////////////////////////////////////////////////////////////
    // Detect hand landmarks in image
    const detectHandLandmarks = async(img) =>{
        try{
            let handLandmarks = await handLandmarksdetector.estimateHands(img,detectorConfigsHand.estimation_configs)
            return handLandmarks
        }
        catch(e){
            console.log(e)
        }
    }

    const detectorCreate = async (all_config,all_config2,all_config3)=>{
        
        globaldetector = await poseDetection.createDetector(
            all_config.model,
            all_config.config
        )
        faceLandmarksdetector = await faceLandmarksDetection.createDetector(
            all_config2.model,
            all_config2.config
        )
        handLandmarksdetector = await handLandmarksDetection.createDetector(
            all_config3.model,
            all_config3.config
        )

    }
    
    useEffect(()=>{
	    console.log('detector')
	    tf.ready()
            detectorCreate(blazepose_configs,facelandmarks_configs,handlandmarks_configs)
            setDetectorConfigs(blazepose_configs)
            setDetectorConfigs(facelandmarks_configs)
            setDetectorConfigs(handlandmarks_configs)
    },[detectorType])
    
    const changeVideoHandler = (event)=>{
        try{
            setSelectedVideo(event?.target?.files[0])
            setIsVideoSelected(true)
        }
        catch(e){
            console.log(e.message)
        }
    }

    useEffect(()=>{
        if(isVideoSelected) submitVideoHandler()
    },[isVideoSelected])

    // handle video sumbission
    const submitVideoHandler = ()=>{
        try{
            setSumbitCounter(old=>old+1)
            videoSrcRef.current.src = URL.createObjectURL(selectedVideo)
            videoRef.current.load();
            setIsVideoLoaded(true)
            setIsVideoProcessed(false)
            setIsVideoSelected(false)
            setUploaderChangeCounter((old)=>old+1)
        }
        catch(e){
            console.log(e.message)
        }
    }

    useEffect(()=>{
        if(isVideoLoaded){
            let demuxer = new MP4Demuxer(videoSrcRef.current.src)
            setVideoDemuxer(demuxer)
        }
    },[submitCounter])

    const videoDurationChangeHandler = ()=>{
        setVideoDuration(videoRef.current.duration)
    }

    const transformLandmarks = (type) =>{
        if(global_vars.frame_count>0){
            global_vars.landmarks.frequency = 1/(global_vars.frame_count / videoRef.current.duration)
        }
        let landmarks = {
            frequency:  Number((global_vars.landmarks.frequency)*1000).toFixed(2),
            landmarks : [],
            frame : []
        }
        global_vars.landmarks.landmarks.forEach((frame,frame_index)=>{
            let new_frame = []
            frame?.forEach(person => {
                let new_person = []
                person.forEach((landmark, f_index) => {
                    if(type ==='csv'){
                        let new_landmark = {
                            x: Number(landmark.x).toFixed(6),
                            y: Number(landmark.y).toFixed(6),
                            // y: videoHeight - Number(landmark.y).toFixed(6),
                            visibility :Number(landmark.score).toFixed(6),
                            id :Number(landmark.id),
                            name : landmark.name
                        }                                
                        new_person.push(new_landmark)
                    }
                    if(type === 'json'){
                        let new_landmark = {
                            x: Number(landmark.x / videoWidth).toFixed(6),
                            y: Number(landmark.y / videoHeight).toFixed(6),
                            visibility :Number(landmark.score).toFixed(6),
                            id :Number(landmark.id),
                            name : landmark.name
                        }
                        new_person.push(new_landmark)
                    }
                });
                new_frame.push(new_person)
            });
            landmarks.landmarks.push(new_frame)
            // landmarks.frame.push(global_vars.images[frame_index])
        })
        return landmarks
    }

    const downloadHandler = (type) =>{
        let a = document.createElement('a')
        if(type === 'json'){
            const metadataContent = JSON.stringify(fillableTableData, null, 2);
            const metadataBlob = new Blob([metadataContent], { type: 'application/json' });
            a.href = URL.createObjectURL(metadataBlob);
            a.download = 'MetaData_'+selectedVideo.name.slice(0,-4)+'.json'
        }
        if(type === 'csv'){
            let landmarks = transformLandmarks('csv')
            let csv_content = canvasUtils.json2csv(landmarks,global_vars.options_copy)
            let csvContent = "data:text/csv;charset=utf-8," 
                + csv_content.map(e => e.join(";")).join("\n");
            a.href = encodeURI(csvContent);
            a.download = 'PLD_'+selectedVideo.name.slice(0,-4)+'.csv'
        }
        a.click()
    }

    const metaDataLoadedHandler = (e)=>{
        videoRef.current.hidden = false
        let width = videoRef.current.videoWidth
        let height = videoRef.current.videoHeight
        setVideoHeight(height)
        setVideoWidth(width)
        if(height>width) setRotate(true)
    }

    function pausecomp(millis)
    {
        var date = new Date();
        var curDate = null;
        do { curDate = new Date(); }
        while(curDate-date < millis);            
    }

    const exportVidHandler_PLD_Video = async () =>{
        let videoWriter = new WebMWriter({
            quality: 0.5,
            fileWriter:null,
            fd: null,
            frameDuration:null,
            frameRate: Number(1000 / transformedLandmarks.frequency),
            //frameRate: 30,
            transparent:false,
            alphaQuality:undefined
        })
        
        var myctx = document.getElementById("exporting_to_video_canvas");  
        myctx.width = 2*videoWidth

        const exportVid = (blob)=>{
            videoToExportRef.current.src = URL.createObjectURL(blob);
            videoToExportRef.current.hidden = false
            videoToExportRef.current.controls = true;
            const a = document.createElement('a');
            a.download = 'Video_PLD_'+selectedVideo.name.slice(0,-4)+'.mp4';
            a.href = videoToExportRef.current.src;
            a.textContent = 'download the video';
            a.click()
        }

        const writeVideo = async () =>{
            transformedLandmarks.landmarks.forEach((frame,f_index)=>{
                exportingToVideoCanvRef.current.getContext('2d').clearRect(0,0,2*videoWidth,videoHeight)
                exportingToVideoCanvRef.current.getContext('2d').fillStyle = 'black'
                exportingToVideoCanvRef.current.getContext('2d').beginPath()
                exportingToVideoCanvRef.current.getContext('2d').rect(0,0,2*videoWidth,videoHeight)
                exportingToVideoCanvRef.current.getContext('2d').fill()
                exportingToVideoCanvRef.current.getContext('2d').closePath()
                exportingToVideoCanvRef.current.getContext('2d').drawImage(transformedLandmarks.frame[f_index], 0, 0,videoWidth,videoHeight);
                canvasUtils.drawLandmarks(exportingToVideoCanvRef.current.getContext('2d'),frame,videoWidth,videoHeight,true)
                videoWriter.addFrame(exportingToVideoCanvRef.current)
            })
            videoWriter.complete().then(function(webMBlob) {
                videoToExportRef.current.src = URL.createObjectURL(webMBlob);
                exportVid(webMBlob)
            });
                         
        }
        await writeVideo();
    }
    
    const exportVidHandler_PLD = async () =>{
        let videoWriter = new WebMWriter({
            quality: 0.5,
            fileWriter:null,
            fd: null,
            frameDuration:null,
            frameRate: Number(1000 / transformedLandmarks.frequency),
            transparent:false,
            alphaQuality:undefined
        })
        
        var myctx = document.getElementById("exporting_to_video_canvas");  
        myctx.width = videoWidth

        const exportVid = (blob)=>{
            videoToExportRef.current.src = URL.createObjectURL(blob);
            videoToExportRef.current.hidden = false
            videoToExportRef.current.controls = true;
            const a = document.createElement('a');
            a.download = 'PLD_'+selectedVideo.name.slice(0,-4)+'.mp4';
            a.href = videoToExportRef.current.src;
            a.textContent = 'download the video';
            a.click()
        }

        const writeVideo = async () =>{
            transformedLandmarks.landmarks.forEach((frame)=>{
                exportingToVideoCanvRef.current.getContext('2d').clearRect(0,0,videoWidth,videoHeight)
                exportingToVideoCanvRef.current.getContext('2d').fillStyle = 'black'
                exportingToVideoCanvRef.current.getContext('2d').beginPath()
                exportingToVideoCanvRef.current.getContext('2d').rect(0,0,videoWidth,videoHeight)
                exportingToVideoCanvRef.current.getContext('2d').fill()
                exportingToVideoCanvRef.current.getContext('2d').closePath()
                canvasUtils.drawLandmarks(exportingToVideoCanvRef.current.getContext('2d'),frame,videoWidth,videoHeight,false)
                videoWriter.addFrame(exportingToVideoCanvRef.current)
            })
            videoWriter.complete().then(function(webMBlob) {
                videoToExportRef.current.src = URL.createObjectURL(webMBlob);
                exportVid(webMBlob)
            });
                         
        }
        await writeVideo();
    }

    const fillFunction = (data)=>{
        try{
            setFillableTableData(data)
        }
        catch(e){
            setFillableTableData([])
        }
        setInfoFilledCounter(old=>old+1)
    }
    
    ///////////////////////////////////////////////////////////////////////////
    // Webcam functions
    
    
    const processVideoWebcam = async ()=> {
        global_vars = {
            frame_count :0,
            nb_frames:0,
            start_time: 0,
            landmarks : {
                frequency : 0.0,
                landmarks:[],
                landmarkConfig:[]
            },
            timestamps: {
                duration:0,
                first_timestamp:0,
                second_timestamp:0,
                step:0
            },
            options : [],
            options_copy :[],
            confLandmarks : [],
            images : []
        }
        setIsWebcamProcessing(true)
        global_vars.options = selectedOptions
        let global_motor_skills_flag = false
        let fine_motor_skills_flag = false
        let face_expression_flag = false
        const endpoints_p = global_vars.options.map(option => {
            switch (option) {
                case 'global_motor_skills':
                    global_motor_skills_flag = true
                    return
                case 'fine_motor_skills':
                    fine_motor_skills_flag = true
                    return
                case 'face_expression':
                    face_expression_flag = true
                    return
                default:
                    return null;
            }
        }).filter(Boolean);
        global_vars.options_copy = JSON.parse(JSON.stringify(global_vars.options))
        if(global_motor_skills_flag && fine_motor_skills_flag && face_expression_flag){
            globallandmarks_include_map[0].include = false
            globallandmarks_include_map[15].include = false
            globallandmarks_include_map[16].include = false
            global_vars.confLandmarks = faceglobalhandlandmarks_include_map
        } else if (global_motor_skills_flag && fine_motor_skills_flag){
            globallandmarks_include_map[15].include = false
            globallandmarks_include_map[16].include = false
            global_vars.confLandmarks = globalhandlandmarks_include_map
        } else if (global_motor_skills_flag && face_expression_flag){
            globallandmarks_include_map[0].include = false
            global_vars.confLandmarks = facegloballandmarks_include_map
        } else if (face_expression_flag && fine_motor_skills_flag){
            globallandmarks_include_map[0].include = false
            globallandmarks_include_map[15].include = false
            globallandmarks_include_map[16].include = false
            globallandmarks_include_map[23].include = false
            globallandmarks_include_map[24].include = false
            globallandmarks_include_map[25].include = false
            globallandmarks_include_map[26].include = false
            globallandmarks_include_map[27].include = false
            globallandmarks_include_map[28].include = false
            global_vars.options_copy.push('global_motor_skills')
            global_vars.confLandmarks = faceglobaltophandlandmarks_include_map
        } else if (fine_motor_skills_flag){
            globallandmarks_include_map[15].include = false
            globallandmarks_include_map[16].include = false
            globallandmarks_include_map[23].include = false
            globallandmarks_include_map[24].include = false
            globallandmarks_include_map[25].include = false
            globallandmarks_include_map[26].include = false
            globallandmarks_include_map[27].include = false
            globallandmarks_include_map[28].include = false
            global_vars.options_copy.push('global_motor_skills')
            global_vars.confLandmarks = globaltophandlandmarks_include_map
        } else if (face_expression_flag){
            global_vars.confLandmarks = facelandmarks_include_map
        } else if (global_motor_skills_flag){
            global_vars.confLandmarks = globallandmarks_include_map
        }
        global_vars.timestamps.duration = 32768
        global_vars.timestamps.step = 0
        global_vars.nb_frames = 100000
        return 0
    }
    
    async function renderResult() {
        if (camera.video.readyState < 2) {
            await new Promise((resolve) => {
                camera.video.onloadeddata = () => {
                    resolve(video);
                };
            });
        }

        let poses = null;
        let canvasInfo = null;
        let canvas_ctx = null
	let flag_clear = false
        try{
            canvas_ctx = canvasWebcamRef.current.getContext('2d')
            }
        catch(e){console.log(e.message)}
        if (canvas_ctx){
	    //canvas_ctx.clearRect(0,0,2*videoWidth,videoHeight)
            //canvas_ctx.fillStyle = 'black'
            //canvas_ctx.beginPath()
            //canvas_ctx.rect(0,0,2*videoWidth,videoHeight)
            //canvas_ctx.fill()
            //canvas_ctx.closePath()
            //canvas_ctx.drawImage(camera.video,0,0,videoWidth,videoHeight)
            let res = null
            const endpoints = global_vars.options_copy.map(option => {
		switch (option) {
                    case 'global_motor_skills':
                        detectPoses(camera.video).then((landmarks)=>{
                            if(landmarks){
                                if(landmarks[0]){
                                    landmarks?.forEach(element => {
                                            res = canvasUtils.liveDrawMovenetLandmarksWebcam(
                                                canvas_ctx,
                                                element,
                                                false,
                                                canvasWebcamRef.current.width,
                                                canvasWebcamRef.current.height,
                                                webcamWidth,
                                                webcamHeight,
                                                option,
						flag_clear
                                                )
                                    });
				flag_clear = true
                                }
                            }
                        })
                        return
                    case 'fine_motor_skills':
                        detectHandLandmarks(camera.video).then((landmarks)=>{
                            if(landmarks){
                               if(landmarks[0]){
                                    landmarks?.forEach(element => {
                                            res = canvasUtils.liveDrawMovenetLandmarksWebcam(
                                                canvas_ctx,
                                                element,
                                                false,
                                                canvasWebcamRef.current.width,
                                                canvasWebcamRef.current.height,
                                                webcamWidth,
                                                webcamHeight,
                                                option,
                                                flag_clear
                                                )
					    flag_clear = true
                                    });
                                }
                            }
                        })
                        return
                    case 'face_expression':
                        detectFaceLandmarks(camera.video).then((landmarks)=>{
                            if(landmarks){
                                if(landmarks[0]){
                                    landmarks?.forEach(element => {
                                            res = canvasUtils.liveDrawMovenetLandmarksWebcam(
                                                canvas_ctx,
                                                element,
                                                false,
                                                canvasWebcamRef.current.width,
                                                canvasWebcamRef.current.height,
                                                webcamWidth,
                                                webcamHeight,
                                                option,
						flag_clear
                                                )
                                    });
				    flag_clear = true
                                }
                            }
                        })
                        return
                    default:
                        return null;
                }
            }).filter(Boolean);
        }
    }
    
    async function renderPrediction() {
        await renderResult();
        rafId = requestAnimationFrame(renderPrediction);
    };
    
    async function startRecording() {
	setIsRecording(true);
        await processVideoWebcam()
        camera = await Camera.setup(STATE.camera);
        const canvas = document.getElementById('output');
        canvas.width = camera.video.width;
        canvas.height = camera.video.height;
        renderPrediction();
    };
    
    const stopRecording = () => {
        setIsRecording(false);
        camera.getTracks().forEach(function(track) { track.stop(); })
    };

    return(
        <>  
            <Container fluid className='bg-white text-dark' style={{ minHeight: '100vh', padding: '20px' }}>
                <div id='main_div' style={{marginTop:'5%'}}>
                    <div className='container mt-5 pb-5'>
                        <Nav
                            className='nav-fill flex-column flex-sm-row justify-content-center'
                            id='tabs-text'
                            pills
                            role='tablist'
                        >  
	    <div className="px-5">
	       <p>{language.main.p3.m}</p>
	    </div>
                            {/* "Video Detection" Button */}
                            <NavItem className='col-4'>
                                <NavLink
                                    aria-selected={!isChoicesVisible}
                                    className={classnames("mb-sm-3 mb-md-0 btn-danger", {
                                        active: !isChoicesVisible
                                    })}
                                    onClick={e => toggleNavs(e, "video")}
                                    href="#pablo"
                                    role="tab"
                                >
                                    {language.video.detection_type.videoDetection}
                                </NavLink>
                            </NavItem>
                            {/* "Webcam Detection" Button */}
                            <NavItem className='col-4'>
                                <NavLink
                                    aria-selected={isChoicesVisible}
                                    className={classnames("mb-sm-3 mb-md-0 btn-danger", {
                                    active: isChoicesVisible
                                    })}
                                    onClick={e => toggleNavs(e, "webcam")}
                                    href="#pablo"
                                    role="tab"
                                >
                                    {language.video.detection_type.webcamDetection}
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>
                    {/* upload button*/}
                    {!isChoicesVisible && (
                            <div className="text-center my-3">
                                <label htmlFor="videofiles" className="custom-file-upload btn btn-info mx-2">
                                    <i className="fa fa-cloud-upload"></i> {language.video.upload_button}
                                </label>
                                <input className='btn' type="file" id="videofiles" name="videos" accept="video/*" multiple onChange={changeVideoHandler} hidden />
                            </div>
                    )}
                    <div>
                        <Container>
                            <Row className='justify-content-center'>
                                <Col xs={12} md={2}>
                                    {/* Display image */}
                                    {selectedImage && (
                                            <div className="text-center my-3">
                                                <img src={selectedImage} alt="Selected Option" style={{ width: '170px' }} />
                                            </div>
                                    )}
                                </Col>
                                <Col xs={12} md={1}></Col>
                                <Col xs={12} md={4}>                                    
                                <p>&nbsp;</p> 
                                    {!isChoicesVisible && (
                                        <InfoFillTable
                                            fillFunction={fillFunction}
                                            //data={{ "video_name": selectedVideos[0]?.name }}
                                        />
                                    )}
                                    {isChoicesVisible ? (
                                        [
                                            { label: language.video.estimation_type.global_motor_skills, value: "global_motor_skills" }, // Global Motor Skills
                                            { label: language.video.estimation_type.fine_motor_skills, value: "fine_motor_skills" }, // Fine Motor Skills
                                            { label: language.video.estimation_type.face_expression, value: "face_expression" }, // Face Expression
                                        ].map(option => (
                                            <Row key={option.value} className="mb-3">
                                                <Col xs={12}>
                                                    <Button
                                                        className={`btn ${selectedOptions.includes(option.value) ? 'btn-danger' : 'btn-primary'} btn-block`}
                                                        onClick={() => {
                                                            if (option.value === "global_motor_skills") {
                                                                handleGlobalMotorSkills();
                                                            } else if (option.value === "fine_motor_skills") {
                                                                handleFineMotorSkills();
                                                            } else if (option.value === "face_expression") {
                                                                handleFaceExpression();
                                                            }           
                                                        }}
                                                        disabled={isChoicesVisible && isRecording}
                                                    >
                                                        {option.label}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))
                                    ) : (
                                        [
                                            { label: language.video.estimation_type.global_motor_skills, value: "global_motor_skills" }, // Global Motor Skills
                                            { label: language.video.estimation_type.fine_motor_skills, value: "fine_motor_skills" }, // Fine Motor Skills
                                            { label: language.video.estimation_type.face_expression, value: "face_expression" }, // Face Expression
                                        ].map(option => (
                                            <Row key={option.value} className="mb-3">
                                                <Col xs={12}>
                                                    <Button
                                                        className={`btn ${selectedOptions.includes(option.value) ? 'btn-danger' : 'btn-primary'} btn-block`}
                                                        onClick={() => {
                                                            if (option.value === "global_motor_skills") {
                                                                handleGlobalMotorSkills();
                                                            } else if (option.value === "fine_motor_skills") {
                                                                handleFineMotorSkills();
                                                            } else if (option.value === "face_expression") {
                                                                handleFaceExpression();
                                                            }
                                                        }}
                                                        disabled={!isChoicesVisible && selectedVideo.length === 0}
                                                    >
                                                        {option.label}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))
                                    )}
                                    {/* video after processing*/}
                                    {isChoicesVisible && (
                                    <Row className="mb-3">
                                                <Col xs={12}>
                                                    <Button
                                                        className={`btn btn-success btn-block ${isRecording ? 'btn-danger' : 'btn-primary'}`}
                                                        onClick={isRecording ? stopRecording : startRecording}
                                                        disabled={isRecording}
                                                    >
                                                    {language.webcam.start_recording}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            )}
                                    {!isChoicesVisible && (
                                        <Row className="mt-4">
                                            <Col xs={12}>
                                                <Button name="buttonStart"
                                                    className="btn btn-success btn-block"
                                                    onClick={() => {
                                                            global_vars.options = selectedOptions;
                                                            handleProcessAllSelectedOptions();
                                                        }
                                                    }
                                                    disabled={selectedOptions.length === 0 || (selectedVideo.length === 0 && !isChoicesVisible) || isVideoProcessing}
                                                >
                                                    {language.video.estimate_pose_btn.ready}
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                            </Row>
                            <hr />
                            <Row className='justify-content-center'>
                                <div className='container'>
                                    <div className='row justify-content-center'>
                                    {/* uploaded video*/}
                                    {!isChoicesVisible && (
                                        <div className='col-md-auto'>
                                            <video hidden muted loop onLoadedMetadata={metaDataLoadedHandler} height={310} width={480} ref={videoRef} id="video" controls onDurationChange={videoDurationChangeHandler}>
                                                <source id="videoSrc" ref={videoSrcRef} src="" type="video/mp4" />
                                            </video>
                                        </div>
                                    )}
                                    {/* video after processing*/}
                                    {
                                        (!isChoicesVisible && isVideoProcessed)?
                                        <div className='col-md-auto'>
                                            <Animator 
                                                    jsonFile={transformedLandmarks}
                                                    uploaderChangeCounter={uploaderChangeCounter}
                                                    width={310*videoWidth/videoHeight}
                                                    height={310}
                                                    noFPS={true}
                                                    isVideoConnected={true}
                                                    connectedVideo={videoRef}
                                            />                            
                                        </div> 
                                        :
                                        <></>
                                    }
                                    {
                                        (!isChoicesVisible && isVideoProcessing) ? 
                                            <div className='col-md-auto mt-3'>
                                                {/* processing display */}
                                                <canvas
                                                    ref={canvasRef}
                                                    className="output_canvas"
                                                    width={310*videoWidth/videoHeight}
                                                    //width={480}
                                                    height={310}
                                                    style={{
                                                        marginLeft: "auto",
                                                        marginRight: "auto",
                                                        left: 0,
                                                        right: 0,
                                                        backgroundColor:"black",
                                                    }}
                                                ></canvas>
                                                <canvas
                                                    hidden
                                                    ref={detectionCanvas}
                                                    className="output_canvas"
                                                    width={videoWidth}
                                                    height={videoHeight}
                                                ></canvas>
                                            </div>
                                            :
                                            <></>                        
                                     }
                                     {/* webcam display */}
                                     {
                                        (isChoicesVisible) ? 
                                            <div className='col-md-auto mt-3'>
                                                {/* processing display */}
                                                <canvas
                                                    ref={canvasWebcamRef}
                                                    className="output_canvas"
                                                    //width={310*videoWidth/videoHeight}
                                                    //height={310}
                                                    width={webcamWidth}
                                                    height={webcamHeight}
                                                    
                                                    style={{
                                                        marginLeft: "auto",
                                                        marginRight: "auto",
                                                        left: 0,
                                                        right: 0,
                                                        backgroundColor:"black",
                                                    }}
                                                ></canvas>
                                            </div>
                                            :
                                            <></>                        
                                     }
                                     {
                                        (isChoicesVisible) ? 
                                            <div className='col-md-auto mt-3'>
                                                {/* processing display */}
                                                {/*
                                                      
                                                */}
                                                <canvas id="output"></canvas>
                                                <video id="videoWebcam" playsInline style={{
                                                      "width": "webcamWidth",
                                                      "height": "webcamHeight",
                                                      "-webkit-transform": "scaleX(-1)",
                                                      "transform": "scaleX(-1)",
                                                      "visibility": "hidden"
                                                  }}>
                                                </video>
                                            </div>
                                            :
                                            <></>                        
                                     }
                                    {
                                        (!isChoicesVisible && isVideoProcessed)?
                                        <div >
                                            <canvas
                                                hidden 
                                                ref={exportingToVideoCanvRef} 
                                                id='exporting_to_video_canvas'
                                                width={videoWidth}
                                                height={videoHeight}
                                                style={{
                                                    marginLeft:'auto',
                                                    marginRight:'auto',
                                                    left:0,
                                                    right:0,
                                                    backgroundColor:'black'
                                                }}
                                            ></canvas>
                                            <br />
                                            <video hidden id='video_to_export' muted loop width={480} height={300} ref={videoToExportRef} controls>
                                                <source type="video/mp4" />
                                            </video>
                                        </div>
                                        :<></>
                                    }
                                </div>
                                </div>
                            </Row> 
                            <hr />
                            <Row className='justify-content-center'>
                                {
                                    (isVideoProcessing)?
                                        //<button className='btn btn-info'>{language.video.estimate_pose_btn.running}</button>
                                        <Row className='justify-content-center'>
                                            <Col xs={12}>
                                                <div className="text-center my-3">
                                                    <h5>{language.video.estimate_pose_btn.running}</h5>
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        :<></>
                                }
                                <div id='noui-process' className='m-auto' style={{width:'50%'}}>
                                    {
                                        (isVideoProcessing) ?
                                        <Nouislider range={{ min: 0, max: (videoDuration) ? videoDuration:0    }} start={[0]} connect={[true,false]} />
                                        :
                                        <></>
                                    }
                                </div>
                            </Row> 
                            <Row className='justify-content-center'>
                                {
                                    (isVideoProcessed) ? 
                                    <div>
                                        <button className='btn btn-success' onClick={()=>{downloadHandler('csv')}}>{language.video.download_landmarks_csv}</button>
                                        {/* <button className='btn btn-success' onClick={()=>{downloadHandler('json')}}>{language.video.download_landmarks_json}</button>*/}
                                        {/* <button ref={exportVidBtnRef} className='btn btn-success' onClick={exportVidHandler_PLD_Video}>{language.video.download_mp4}</button>*/}
                                        <button ref={exportVidBtnRefPLD} className='btn btn-success' onClick={exportVidHandler_PLD}>{language.video.download_mp4_PLD}</button>
                                        <button className='btn btn-success' onClick={()=>{downloadHandler('json')}}>{language.video.download_metadata}</button>
                                    </div>
                                    :<></>
                                    //(
                                    //    (!isVideoProcessing) ?
                                    //    <button className='btn btn-dark' onClick={()=>{
                                    //        processVideoHandler()
                                    //    }}>{language.video.estimate_pose_btn.ready}</button>
                                    //    :
                                    //    <button className='btn btn-info'>{language.video.estimate_pose_btn.running}</button>
                                    //)
                                }
                            </Row> 
                        </Container>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default Detector
